export enum COURSE_TYPE {
  SECTION = 'section',
  TEXT = 'text',
  VIDEO = 'video',
  IMAGE = 'image',
  QUIZ = 'quiz',
}
